module.exports = "/_next/static/images/f6185be189a34882e4c294b6ab18b651-card-xs.png";